/** All actions that need permission go here. */
export enum PermissionAction {
  WORKSPACE_SETTINGS_READ = "WORKSPACE_SETTINGS_READ",
  WORKSPACE_SETTINGS_UPDATE = "WORKSPACE_SETTINGS_UPDATE",
  WORKSPACE_SETTINGS_DELETE = "WORKSPACE_SETTINGS_DELETE",
}

/** What owner can do, but admin & member cannot. */
export const ownerActions: PermissionAction[] = [
  PermissionAction.WORKSPACE_SETTINGS_DELETE,
];

/** What admin can do, but member cannot. */
export const adminActions: PermissionAction[] = [
  PermissionAction.WORKSPACE_SETTINGS_UPDATE,
];

// What member can do
export const memberActions: PermissionAction[] = [
  PermissionAction.WORKSPACE_SETTINGS_READ,
];
